import { memo } from 'react';
import NavigationHeaderWapper from '../navigation-header-wapper';
import ProjectSelect from './project-select';
import { isWeApp } from '@/sub-luca-plugin/utils';
import { IProjectSelectProps } from './helper';
import classNames from 'classnames';
import './index.scss';

const ProjectSelectOverlay = (props: IProjectSelectProps & { hideBack?: boolean }) => {
    return (
        <div className={classNames('project-select-select-overlay', props.overlayClassName)}>
            {isWeApp && !props.hideBack && <NavigationHeaderWapper className="project-select-select__header" />}
            <ProjectSelect {...props} />
        </div>
    );
};

export default memo(ProjectSelectOverlay);
